import React from 'react';
import { Redirect } from 'react-router-dom';

import Brand from '../../components/Brand';
import { FormLogin } from '../../components/FormLogin';
import { validaAcessoMenu } from '../../routes/menus/validador';
import { AuthConsumer } from '../../security/authContext';
import { BackgroundLogin, ContainerLogin } from './styles';

export const Login = () => (
  <BackgroundLogin type="flex" align="middle" justify="center">
    <ContainerLogin>
      <Brand type="login" size="md" />
      <AuthConsumer>
        {({ authenticated, user, initiateLogin }) => {
          let redirectPath;
          if (user.permissions) {
            redirectPath = validaAcessoMenu(user);
          }
          if (authenticated) return <Redirect to={redirectPath || '/perfil'} />;
          return <FormLogin initiateLogin={initiateLogin} />;
        }}
      </AuthConsumer>
    </ContainerLogin>
  </BackgroundLogin>
);
